import CreditCardIcon from '@mui/icons-material/CreditCard';
import FmdBadRoundedIcon from '@mui/icons-material/FmdBadRounded';
import { Box, Tooltip } from '@mui/material';
import React from 'react';
import PaymentMethod3XWebIcon from '../../svg-icons/PaymentMethod3XWebIcon';
import PaymentMethod4XWebIcon from '../../svg-icons/PaymentMethod4XWebIcon';
import PaymentMethodAlmaIcon from '../../svg-icons/PaymentMethodAlmaIcon';
import PaymentMethodApplePayIcon from '../../svg-icons/PaymentMethodApplePayIcon';
import PaymentMethodBancontactIcon from '../../svg-icons/PaymentMethodBancontactIcon';
import PaymentMethodCBIcon from '../../svg-icons/PaymentMethodCBIcon';
import PaymentMethodEPSIcon from '../../svg-icons/PaymentMethodEPSIcon';
import PaymentMethodFintectureIcon from '../../svg-icons/PaymentMethodFintectureIcon';
import PaymentMethodGiropayIcon from '../../svg-icons/PaymentMethodGiropayIcon';
import PaymentMethodGooglePayIcon from '../../svg-icons/PaymentMethodGooglePayIcon';
import PaymentMethodIdealIcon from '../../svg-icons/PaymentMethodIdealIcon';
import PaymentMethodP24Icon from '../../svg-icons/PaymentMethodP24Icon';
import PaymentMethodPaypalIcon from '../../svg-icons/PaymentMethodPaypalIcon';
import PaymentMethodREAIcon from '../../svg-icons/PaymentMethodREAIcon';
import PaymentMethodSofortIcon from '../../svg-icons/PaymentMethodSofortIcon';
import PaymentMethodVirementIcon from '../../svg-icons/PaymentMethodVirementIcon';
import ErrorBoundary from '../errors/ErrorBoundary';
import InternalServerError from '../errors/InternalServerError.jsx';

const selectPaymentMethodIcon = (props) => {
  const { paymentmethod } = props;

  switch (paymentmethod?.toLowerCase()) {
    case 'cb':
      return <PaymentMethodCBIcon {...props} />;
    case 'paypal':
      return <PaymentMethodPaypalIcon {...props} />;
    case 'giropay':
      return <PaymentMethodGiropayIcon {...props} />;
    case 'sofort':
      return <PaymentMethodSofortIcon {...props} />;
    case 'p24':
      return <PaymentMethodP24Icon {...props} />;
    case 'ideal':
      return <PaymentMethodIdealIcon {...props} />;
    case 'bancontact':
      return <PaymentMethodBancontactIcon {...props} />;
    case 'eps':
      return <PaymentMethodEPSIcon {...props} />;
    case 'sepa':
      return <CreditCardIcon {...props} />;
    case '3xweb':
      return <PaymentMethod3XWebIcon {...props} />;
    case '4xweb':
      return <PaymentMethod4XWebIcon {...props} />;
    case 'fintecture':
      return <PaymentMethodFintectureIcon {...props} />;
    case 'virement':
      return <PaymentMethodVirementIcon {...props} />;
    case 'applepay':
      return <PaymentMethodApplePayIcon {...props} />;
    case 'googlepay':
      return <PaymentMethodGooglePayIcon {...props} />;
    case 'alma':
      return <PaymentMethodAlmaIcon {...props} />;
    case 'rea':
      return <PaymentMethodREAIcon {...props} />;
    default:
      return <FmdBadRoundedIcon {...props} />;
  }
};

const PaymentMethodIcon = (props) => {
  const { paymentmethod } = props;

  return (
    <ErrorBoundary
      fallback={<InternalServerError />}
      source="PaymentMethodIcon"
    >
      <Tooltip placement="top" title={`${paymentmethod}`}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          {paymentmethod ? selectPaymentMethodIcon(props) : null}
        </Box>
      </Tooltip>
    </ErrorBoundary>
  );
};

export default PaymentMethodIcon;
